import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=7644a45c&scoped=true"
import script from "./LostPassword.vue?vue&type=script&lang=js"
export * from "./LostPassword.vue?vue&type=script&lang=js"
import style0 from "./LostPassword.vue?vue&type=style&index=0&id=7644a45c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644a45c",
  null
  
)

export default component.exports